import React, { useState, useEffect } from "react";
import { Link,useLocation } from "react-router-dom";
import { Modal,Switch, Slider,Space } from 'antd';
import Sam from '../../assest/background/Sam.png';
import Dave from '../../assest/background/Dave.png';
import Tea from '../../assest/image/tea.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apiCall from '../../api/auth';
import BarGraph from '../RealState/GraphComponent';
import { useDataContext } from '../DataContext';
import question from '../../assest/image/question.svg';
import playBotton from '../../assest/image/play-button.png'
import pauseBotton from '../../assest/image/pause-button.png'

function PersonalizeSimulationDecisionMaking() {
  
  document.title = "SimWealth";
  const { formData } = useDataContext();

  const [rentalProperty, setRentalProperty] = useState(() => {
    const _formDT = JSON.parse(localStorage.getItem('formData'));
    const _storedData = _formDT.pageNumOfRentalProperty;
    return _storedData.formData;
  });

  const [mortgageInformation, setMortgageInformation] = useState(() => {
    const __formDT = JSON.parse(localStorage.getItem('formData'));
    const __storedData = __formDT.pageMortgageInformation;
    return __storedData.formData;
  });
  
  
  const [GraphMaxData, setGraphMaxData] = useState([100]);
  const pushGraphMaxData = (newValue) => {
    setGraphMaxData((prevData) => [...prevData, newValue]);
  };
  //Side Navigation
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);
  const toggleSidenav = () => {
    setIsSidenavOpen(!isSidenavOpen);
  };

  const GetColor=(value)=>{
    if (value === 1) {
      return 'text-success';
    } else if (value === 0) {
      return 'text-danger';
    } else {
      return 'text-primary';
    }
  }

  //Chart Optionsnpm run build
  const chartOptions = {
    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: 1.8,
    scales: {
      x: {
        display: true,
        ticks: { color: '#000', beginAtZero: true },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        display: true,
        ticks: { color: '#000', beginAtZero: true
      },
        max: Math.max(...GraphMaxData),
        beginAtZero: true,
        min: Math.min(...GraphMaxData) ,
        grid: {
          drawBorder: false,
          display: true,
          color:(content)=>{
          const  zeroline =content.tick.value;
          const gridcolor = zeroline === 0 ? '#666': '#ccc'
            return gridcolor
          }
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        title: {
          display: false,
        },
      },
      datalabels: {
        color: 'black',
        font: {
          size: 16,
          weight: 'bold',
        },
        anchor: 'center',
        align: 'center',
        formatter: (value, context) => {
          if (context.datasetIndex === 0 && context.dataIndex === 1) { // Check for Gain in Dollars
            return `${value}%`; // Format as money
          } else {
            const formattedPercentage = (value); // Calculate and format percentage
            return `${formattedPercentage}%`; // Format others as percentages
          }
        },
      },
    },
  };

 //toaster setting
  const toasterSetting = { position: toast.POSITION.TOP_RIGHT };

  const [responseData, setResponse] = useState();
  const [inputValue, setInputValue] = useState(0);

  // hide and show
  const [isVisible, setIsVisible] = useState(false);
  const [coffeeCharToogle, setCoffeeCharToogle] = useState(false);
  const [numericalResultsToogle, setNumericalResultsToogle] = useState(false);
  const [exposureToInflationToogle, setExposureToInflationToogle] = useState(false);
  const [realTaxRateToogle, setRealTaxRateToogle] = useState(false);

  const [exposureToogleDisable, setExposureToInflationToogleDisable] = useState(true);
  const [realTaxRateToogleDisable, setRealTaxRateToogleDisable] = useState(true);
  const [coffeeCharToogleDisable, setCoffeeCharToogleDisable] = useState(true);

  // open modal
  const [open, setOpen] = useState(false);
  const showModal = () => setOpen(true);
  const handleOk = () => setOpen(false);
  
  // Coffie Contant Data
  const DAVEDATA = {
    level: 'has not changed',
    from: '0',
    to: '0',
    year: 0,
    coffees_equity: 0,
    coffees_cashflow:0,
    result:{
      year :0,
      made:"0k",
      inflation: "0%",
      taxRate:"0%",
      with:"NO CHANGE",
      withOf:"0%"
    }
  }

  const SAMDATA = {
    level: 'has not changed',
    from: '0',
    to: '0',
    year: 0,
    coffees_equity: 0,
    coffees_cashflow: 0,
    result:{
      year :0,
      made:"0k",
      inflation: "0%",
      taxRate:"0%",
      with:"NO CHANGE",
      withOf:"0%"
    }
  }

  const [daveCoffeeData, setDaveCoffeeData] = useState(DAVEDATA);
  const [samCoffeeData, setSamCoffeeData] = useState(SAMDATA);

  const [samChartDT, setSamChartDT] = useState({
    purchasingPower: 0,
    // gainInDollars: 0,
    realTaxRate: 0,
    exposureToInflation: 0
  });

  const [daveChartDT, setDaveChartDT] = useState({
    purchasingPower: 0,
    // gainInDollars: 0,
    realTaxRate: 0,
    exposureToInflation: 0
  });

  //chart Data 
  const samChartData =  {
    labels: ['Purchasing Power','Real Tax Rate', 'Exposure to Inflation'],
    datasets: [
      {
        label: 'Data',
        backgroundColor: (context) => {
          const index = context.dataIndex;
          const value = context.dataset.data[index];
          if(index === 0){
            if(value >=0) return 'green'
            else  return 'red' 
           
            }else {
            return '#FF0001';
            }
        },
        borderColor: 'gray',
        borderWidth: 1,
        hoverBackgroundColor: (context) => {
          const index = context.dataIndex;
          return context.dataset.backgroundColor[index]; 
        },
        hoverBorderColor: 'gray',
        data: Object.values(samChartDT),
      },
    ],
  };

  const daveChartData =  {
    labels: ['Purchasing Power',  'Real Tax Rate', 'Exposure to Inflation'],
    datasets: [
      {
        label: 'Data',
        backgroundColor: (context) => {
          const index = context.dataIndex;
          const value = context.dataset.data[index];

          if(index === 0){
            if(value >=0) return 'green'
            else  return 'red' 
           
            }else {
            return '#FF0001';
            }
        },
        borderColor: 'gray',
        borderWidth: 1,
        hoverBackgroundColor: (context) => {
          const index = context.dataIndex;
          return context.dataset.backgroundColor[index]; 
        },
        hoverBorderColor: 'gray',
        data: Object.values(daveChartDT),
      },
    ],
  };

  // Common functions
  const PlayPauseBottonHandle = () => {
    
    setIsVisible(true);
    SliderValueUpdate(inputValue)

    setCoffeeCharToogle(true);
    setNumericalResultsToogle(false);
    setExposureToInflationToogle(false);
    setRealTaxRateToogle(false);

    setExposureToInflationToogleDisable(false);
    setRealTaxRateToogleDisable(false);
    setCoffeeCharToogleDisable(false);
  };

  const coffeeCharToogleHandle = () => {

    setCoffeeCharToogle(!coffeeCharToogle);
    setNumericalResultsToogle(!numericalResultsToogle);
    setExposureToInflationToogle(!exposureToInflationToogle);
    setRealTaxRateToogle(!realTaxRateToogle);

    setInputValue(0);
    setIsPlayingAutomatically(false);
    setIntervalId(false);
  };

  const numericalResultsToogleHandle=()=>{
    setCoffeeCharToogle(!coffeeCharToogle);
    setNumericalResultsToogle(!numericalResultsToogle);
    setExposureToInflationToogle(!exposureToInflationToogle);
    setRealTaxRateToogle(!realTaxRateToogle);
  }

  const exposureToInflationToogleHandle=()=>{
    setExposureToInflationToogle(!exposureToInflationToogle);

    SliderValueUpdate(inputValue);
    SetResponceData(responseData,inputValue);
  }

  const realTaxRateToogleHandle=()=>{
    
    setRealTaxRateToogle(!realTaxRateToogle);

    SliderValueUpdate(inputValue);
    SetResponceData(responseData,inputValue)
  }

  const handleModel=()=>{
    setOpen(true);
    showModal();
  }
  

  const SliderValueUpdate =(yearVal) =>{

    const data = [
      {
         "appreciationRate": parseFloat((rentalProperty.appreciationRate / 100).toFixed(4)),
         "startingAssetValue": parseFloat(rentalProperty.propertyValue),
         "taxRate": parseFloat((rentalProperty.taxRateOnGainUponSale / 100).toFixed(4)),
         "yearsToHoldAsset": 20,
         "inflationRate": parseFloat((rentalProperty.inflationRate / 100).toFixed(4)),
         "ltvAtRefinance": 0,
         "minCashOutRefiAmount": 30000,
         "monthlyGrossIncome": parseFloat(rentalProperty.monthlyRent),
         "monthlyExpenses": parseFloat(rentalProperty.monthlyExpenses),
         "monthlyLoanPayments": 0,
         "yearsForCalculator": 20,
         "loans": [
             {
                 "loanLtv": 0,
                 "loanAmount": 0,
                 "interestRate": parseFloat((mortgageInformation.loanInterestRate / 100).toFixed(4)),
                 "loanPeriodInYears": parseInt(mortgageInformation.periodInYears),
                 "loanType": mortgageInformation.loanType
             }]
       },
      {
         "appreciationRate": parseFloat((rentalProperty.appreciationRate / 100).toFixed(4)),
         "startingAssetValue": parseFloat(rentalProperty.propertyValue),
         "taxRate": parseFloat((rentalProperty.taxRateOnGainUponSale / 100).toFixed(4)),
         "yearsToHoldAsset": 20,
         "inflationRate": parseFloat((rentalProperty.inflationRate / 100).toFixed(4)),
         "ltvAtRefinance": 0,
         "minCashOutRefiAmount": 30000,
         "monthlyGrossIncome": parseFloat(rentalProperty.monthlyRent),
         "monthlyExpenses": parseFloat(rentalProperty.monthlyExpenses),
         "monthlyLoanPayments": 0,
         "yearsForCalculator": 20,
         "loans": [
             {
                 "loanLtv": parseFloat((mortgageInformation.loanLTV / 100).toFixed(4)),
                 "loanAmount": (rentalProperty.propertyValue * parseFloat((mortgageInformation.loanLTV / 100).toFixed(4))),
                 "interestRate": parseFloat((mortgageInformation.loanInterestRate / 100).toFixed(4)),
                 "loanPeriodInYears": parseInt(mortgageInformation.periodInYears),
                 "loanType": mortgageInformation.loanType
             }]
      },
    ]

    setInputValue(yearVal);
    if(responseData == null){
      onSliderChange(data,yearVal);
    }else{
      SetResponceData(responseData,yearVal);
    }
  }

  const onSliderChange =  (data,yearVal) => {
    
    apiCall.InvestZenTwo(data).then(result => {
      if (result) {
        setResponse(result);
        SetResponceData(result,yearVal)
        setPlayBottonVisible(true);
      } else {
        toast.error("Something went wrong!", toasterSetting);
      }
    })
    .catch(error => {
      toast.error("Something went wrong!", toasterSetting);
    });
  };

  const SetResponceData =(response,yearVal)=>{
    const DaveData = response[0];
    const SamData = response[1];
    SetSamData(SamData,yearVal);
    SetDaveData(DaveData,yearVal)
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////   SAM      ///////////////////////////

  const SetSamData = (samData,yearVal)=>{
    
    const samSelectedYearData = samData.data[yearVal];
    //coffee level
    if(samSelectedYearData.coffeeYouCanPurchase > samData.startingCoffeeYouCanPurchase)
      setSamCoffeeData(prevData => ({ ...prevData, level: ['increased',1] }));
    else if(samSelectedYearData.coffeeYouCanPurchase < samData.startingCoffeeYouCanPurchase)
      setSamCoffeeData(prevData => ({ ...prevData, level: ['decreased',0] }));
    else
      setSamCoffeeData(prevData => ({ ...prevData, level: ['has not changed',-1] }));

    //coffee from
    setSamCoffeeData(prevData => ({ ...prevData, from: samData.startingCoffeeYouCanPurchase.toLocaleString() }));
    //coffee to
    setSamCoffeeData(prevData => ({ ...prevData, to: Math.round(samSelectedYearData.coffeeYouCanPurchase).toLocaleString()}));
    //coffee year
    setSamCoffeeData(prevData => ({ ...prevData, year: samSelectedYearData.year }));

    //Change in Equity Since Beginning (in coffees)
    var _increaseInPurchasingPower = (samSelectedYearData.increaseInPurchasingPower * 100);
    if(_increaseInPurchasingPower > 0){
      setSamCoffeeData(prevData => ({ ...prevData, coffees_equity: ["+"+_increaseInPurchasingPower.toFixed(0),1]}));
    }else if(_increaseInPurchasingPower < 0){
      setSamCoffeeData(prevData => ({ ...prevData, coffees_equity:  ["-"+_increaseInPurchasingPower.toFixed(0),0]}));
    }else{
      setSamCoffeeData(prevData => ({ ...prevData, coffees_equity:  [_increaseInPurchasingPower.toFixed(0),-1]}));
    }
    
    //Change in Cash Flow Since Beginning (in coffees)
    var _cashflow = (samSelectedYearData.increaseInPurchasingPowerFromCashFlow * 100);
    if(_cashflow > 0){
      setSamCoffeeData(prevData => ({ ...prevData, coffees_cashflow: ["+"+_cashflow.toFixed(0),1]}));
    }else if(_cashflow < 0){
      setSamCoffeeData(prevData => ({ ...prevData, coffees_cashflow:  ["-"+_cashflow.toFixed(0),0]}));
    }else{
      setSamCoffeeData(prevData => ({ ...prevData, coffees_cashflow:  [_cashflow.toFixed(0),-1]}));
    }

    //Result year
    setSamCoffeeData(prevData => ({ ...prevData, result: 
        { ...prevData.result, year: samSelectedYearData.year}}));
    
    //Result made
    var _equityBeforeSelling = (Math.round(samSelectedYearData.appreciatedAmount)).toLocaleString();
    setSamCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, made: "$" + _equityBeforeSelling}}));

    //Result tex rate
    var taxes = (samSelectedYearData.realTaxes * 100).toFixed(2);
    setSamCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, taxRate: taxes+"%"}}));
    
    //Result inflation
    var inflation = ((1 - samData.loans[0].loanLtv) * 100).toFixed(2)
    setSamCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, inflation: inflation+"%"}}));

    //Result With
    var _resultWith = ["NO CHANGE",-1]
    if(samSelectedYearData.increaseInPurchasingPower > 0){
      _resultWith = ["GAIN",1];
    }else if(samSelectedYearData.increaseInPurchasingPower < 0){
      _resultWith = ["LOSS",0];
    }
    setSamCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, with: _resultWith}}));

    //Result With Of
    var withof = (samSelectedYearData.increaseInPurchasingPower * 100).toFixed(2)+"%"
    setSamCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, withOf: withof}}));

    //Graph Data Set
    
    // purchasingPower
    var _purchasingPower = (samSelectedYearData.increaseInPurchasingPower * 100).toFixed(0) 
    setSamChartDT(prevData => ({ ...prevData, purchasingPower : parseFloat(_purchasingPower)}));
    pushGraphMaxData(parseFloat(_purchasingPower))
    
    // realTaxRate
    var _realTaxRate = (samSelectedYearData.realTaxes * 100).toFixed(0);
    if(realTaxRateToogle){
      setSamChartDT(prevData => ({ ...prevData, realTaxRate : parseFloat(_realTaxRate)})); 
      pushGraphMaxData(parseFloat(_realTaxRate))
    }else{
      setSamChartDT(prevData => ({ ...prevData, realTaxRate : 0})); 
      pushGraphMaxData(0)
    }
    
    //exposureToInflation
    var _exposureToInflation = ((1 - samData.loans[0].loanLtv) * 100).toFixed(0);
    if(exposureToInflationToogle){
      setSamChartDT(prevData => ({ ...prevData, exposureToInflation : parseFloat(_exposureToInflation)}));
      pushGraphMaxData(parseFloat(_exposureToInflation))
    }else{
      setSamChartDT(prevData => ({ ...prevData, exposureToInflation : 0}));
      pushGraphMaxData(0)
    }
    
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////   DAVE      ///////////////////////////

  const SetDaveData = (daveData,yearVal)=>{

    const SelectedYearData = daveData.data[yearVal];

    //coffee level
    if(SelectedYearData.coffeeYouCanPurchase > daveData.startingCoffeeYouCanPurchase)
      setDaveCoffeeData(prevData => ({ ...prevData, level: ['increased',1] }));
    else if(SelectedYearData.coffeeYouCanPurchase < daveData.startingCoffeeYouCanPurchase)
      setDaveCoffeeData(prevData => ({ ...prevData, level: ['decreased',0] }));
    else
      setDaveCoffeeData(prevData => ({ ...prevData, level: ['has not changed',-1] }));


    //coffee from
    setDaveCoffeeData(prevData => ({ ...prevData, from: daveData.startingCoffeeYouCanPurchase.toLocaleString() }));
    //coffee to
    setDaveCoffeeData(prevData => ({ ...prevData, to: Math.round(SelectedYearData.coffeeYouCanPurchase).toLocaleString() }));
    //coffee year
    setDaveCoffeeData(prevData => ({ ...prevData, year: SelectedYearData.year }));


    //Change in Equity Since Beginning (in coffees)
    var __increaseInPurchasingPower_dave = (SelectedYearData.increaseInPurchasingPower * 100);
    if(__increaseInPurchasingPower_dave > 0){
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_equity: ["+"+__increaseInPurchasingPower_dave.toFixed(0),1]}));
    }else if(__increaseInPurchasingPower_dave < 0){
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_equity:  ["-"+Math.abs(__increaseInPurchasingPower_dave.toFixed(0)),0]}));
    }else{
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_equity:  [__increaseInPurchasingPower_dave.toFixed(0),-1]}));
    }

    //Change in Cash Flow Since Beginning (in coffees)
    var __cashflow_dave = (SelectedYearData.increaseInPurchasingPowerFromCashFlow * 100);
    if(__cashflow_dave > 0){
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_cashflow: ["+"+ __cashflow_dave.toFixed(0),1]}));
    }else if(__cashflow_dave < 0){
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_cashflow:  ["-"+ __cashflow_dave.toFixed(0) ,0]}));
    }else{
      setDaveCoffeeData(prevData => ({ ...prevData, coffees_cashflow:  [__cashflow_dave.toFixed(0),-1]}));
    }

    //Result year
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
        { ...prevData.result, year: SelectedYearData.year}}));
    
    //Result made
    var __equity = (Math.round(SelectedYearData.appreciatedAmount)).toLocaleString();
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, made: "$" + __equity}}));

    //Result tex rate
    var __taxes = (SelectedYearData.realTaxes * 100).toFixed(2);
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, taxRate: __taxes+"%"}}));
    
    //Result inflation
    var __inflation = ((1 - daveData.loans[0].loanLtv) * 100).toFixed(2)
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, inflation: __inflation+"%"}}));

    //Result With
    var __resultWith = ["NO CHANGE",-1]
    if(SelectedYearData.increaseInPurchasingPower > 0){
      __resultWith = ["GAIN",1];
    }else if(SelectedYearData.increaseInPurchasingPower < 0){
      __resultWith = ["LOSS",0];
    }
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, with: __resultWith}}));

    //Result With Of
    var __withof = (SelectedYearData.increaseInPurchasingPower * 100).toFixed(2)+"%"
    setDaveCoffeeData(prevData => ({ ...prevData, result: 
      { ...prevData.result, withOf: __withof}}));

    //Graph Data Set

    // purchasingPower
    var __purchasingPower = (SelectedYearData.increaseInPurchasingPower * 100).toFixed(0) 
    setDaveChartDT(prevData => ({ ...prevData, purchasingPower : parseFloat(__purchasingPower)}));
    pushGraphMaxData(parseFloat(__purchasingPower))
    // realTaxRate
    var __realTaxRate = (SelectedYearData.realTaxes * 100).toFixed(0);
    if(realTaxRateToogle){
      setDaveChartDT(prevData => ({ ...prevData, realTaxRate : parseFloat(__realTaxRate)})); 
      pushGraphMaxData(parseFloat(__realTaxRate))
    }else{
      setDaveChartDT(prevData => ({ ...prevData, realTaxRate : 0})); 
      pushGraphMaxData(0)
    }

    //exposureToInflation
    var __exposureToInflation = ((1 - daveData.loans[0].loanLtv) * 100).toFixed(0);
    if(exposureToInflationToogle){
      setDaveChartDT(prevData => ({ ...prevData, exposureToInflation : parseFloat(__exposureToInflation)}));
      pushGraphMaxData(parseFloat(__exposureToInflation))
    }else{
      setDaveChartDT(prevData => ({ ...prevData, exposureToInflation : 0 }));
      pushGraphMaxData(0)
    }

  }

  //  warming modal
  const [purchasingPowerModalOpen, setpurchasingPowerModalOpen] = useState(false);
  const [realTaxRateModalOpen, setrealTaxRateModalOpen] = useState(false);
  const showWarningpurchasingPower = () => {
    setpurchasingPowerModalOpen(true);
  };
  const showWarningrealTaxRate = () => {
    setrealTaxRateModalOpen(true);
  };

  //Auto timer
  const [playBottonVisible, setPlayBottonVisible] = useState(false);
  const [isPlayingAutomatically, setIsPlayingAutomatically] = useState(false);
  const [intervalId, setIntervalId] = useState(false);
  
  const PlayBottonHandle=()=>{
    setIsPlayingAutomatically(!isPlayingAutomatically);
    if(!isPlayingAutomatically){
      startInterval();
    }else{
      clearInterval(intervalId); 
    }
  }

  const startInterval = () => {
    setIntervalId(setInterval(() => {
      setInputValue((prevInputValue) => {
        let newInputValue = prevInputValue + 1;
        
        if (newInputValue === 20) {
          clearInterval(intervalId);
          setIntervalId(null);
          setIsPlayingAutomatically(false);
        }else{
          newInputValue = newInputValue;
        }

        SetResponceData(responseData, newInputValue);
        return newInputValue;
      });
    }, 2000));
  };

  

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);
 //End Auto timer

  return (
    <>
      <div className="bg bg-InvestRealState1 fs-18" id="main" style={{ marginRight: isSidenavOpen? '25%' : '0',background:'#BEBEBE!important' }}>
        <div data-aos="fade-center" className="container d-flex  align-items-center justify-content-between ">
           {/* radio */}
            <div className='d-flex flex-column align-items-end justify-content-end'>
            <Space >
                 <p className='mb-0'>Toggle Coffee/Bar Charts</p>
                 <Switch   checkedChildren="Coffee" unCheckedChildren="Bar Chart" disabled={coffeeCharToogleDisable} onChange={coffeeCharToogleHandle} checked={coffeeCharToogle} />
                </Space>
               
                {/* <Space >
                  <p className='mb-0'>Show Numerical Results </p>
                   <Switch  checkedChildren="Yes" unCheckedChildren="No" onChange={numericalResultsToogleHandle} checked={numericalResultsToogle}/>
                </Space>  */}
                {/* <Space > 
                  <p className='mb-0'>Show Exposure to Inflation</p>
                  <Switch  checkedChildren="Yes" unCheckedChildren="No" disabled={exposureToogleDisable} onChange={exposureToInflationToogleHandle} checked={exposureToInflationToogle}/>
                </Space> 
                <Space >
                  <p className='mb-0'>Show Real Tax Rate</p>
                  <Switch  checkedChildren="Yes" unCheckedChildren="No" disabled={realTaxRateToogleDisable} onChange={realTaxRateToogleHandle} checked={realTaxRateToogle} />
                </Space>  */}
               
                 
            </div>
            {/* slider */}
            <div className=" d-flex flex-column justify-content-center align-items-start  text-center w-40">
                <div className="bg-white rounded-border py-2 my-3  px-5 border border-4 border-dark">
                  <p className="py-1">Click <b>START SIMULATION</b> and drag the timeline slider to see the impact of their decisions over time.</p>
                  {!playBottonVisible ?
                  <button onClick={PlayPauseBottonHandle}  className=" threeDButton btn btn-sm fw-bold  w-50  ">{'Start Simulation'} 
                  </button> : 
                  <button onClick={PlayBottonHandle}  className=" threeDButton btn btn-sm fw-bold  w-50  ">{isPlayingAutomatically ? "Pause":"Play" } 
                  </button>
                  }
                  <div className='px-4 mt-3 d-block'> 
                    <p className='text-center fs-14'> 

                    {/* {playBottonVisible &&
                      <img className="img-play" src={isPlayingAutomatically ? pauseBotton : playBotton } onClick={PlayBottonHandle} alt="" title={isPlayingAutomatically ? "Pause":"Play" }  width={20}></img> 
                    }  */}
                    Timeline : &nbsp;Year {inputValue}</p>
                   
                    <Slider min={0} max={20} onChange={SliderValueUpdate} value={inputValue} />
                  </div> 
                </div>
            </div>
            {/* button */}
            <div className="d-flex flex-column align-items-center justify-content-center">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold  ">Main Menu</Link>
            <Space >
                <img src={question} width={40} alt="" height={40}></img><p className='mb-0'> What Am I Looking At?</p>
                 <Switch   checkedChildren="Hide" unCheckedChildren="Show" onChange={toggleSidenav} checked={isSidenavOpen} />
                </Space>
            <Link to={'/personalize-simulation/what-was-the-better-decision'} className=" threeDButton btn fw-bold  mb-3">Show Me Main Takeaways</Link>
            
            {/* <Link className=" threeDButton btn fw-bold" onClick={handleModel}>Show Me Lesson</Link> */}
            </div>
        </div>

        {isVisible && (
          <div>
            {/* row1 */}
            <div className="row mx-4">
              <div className="col-sm-6 col-md-6 px-1 leftArea">
                  <div className='  d-flex  align-items-center justify-content-end '>
                  <img className="CharacterImage left-3" src={Dave} alt="Dave"/>
                  <div className='border bg-lightGray border-4 p-3 border-dark d-flex  align-items-start justify-content-start w-83'>
                    <img width="45" height="45" src={Tea} alt="coffee"/>
                    <p className="text-justify text-end" style={{width:"100%"}}>Dave's ability to purchase coffee <b className={ GetColor(daveCoffeeData.level[1]) }  >{daveCoffeeData.level[0]} </b> from <br></br><b>{daveCoffeeData.from}</b> coffees to <b>{daveCoffeeData.to}</b> coffees in <b>{daveCoffeeData.year}</b> years</p>
                  </div>
                  </div>
              </div>
              <div className="col-sm-6 col-md-6 px-1 RightArea"> 
                  <div className=' d-flex   align-items-center justify-content-start '>
                    <div className='border bg-lightGray border-4 p-3 border-dark d-flex w-83 align-items-start justify-content-start text-start'>
                    <p className="text-justify" style={{width:"100%"}}>Sam’s ability to purchase coffee <b className={ GetColor(samCoffeeData.level[1]) }>{samCoffeeData.level[0]}</b> from<br></br> <b>{samCoffeeData.from}</b> coffees to <b>{samCoffeeData.to}</b> coffees in <b>{samCoffeeData.year}</b> years</p>
                      <img className="float-end" width="45" height="45" src={Tea} alt="coffee"/>
                    </div>
                    <img className="CharacterImage right-1"  src={Sam} alt="Sam"/>
                  </div>
              </div>
            </div>

            {/* row 2 */}
          
            {/* coffee box */}
              <div style={{display: `${coffeeCharToogle ? 'block':'none'}`}}>
                <div className="row mx-4"> 
                    {/* Dave */}
                    <div className="col-sm-6 col-md-6 px-1 leftArea">
                      <div className="d-flex bg-lightGray p-3 my-2 align-items-center justify-content-around border border-4 border-dark ">
                              <div className="d-flex gap-2  flex-column align-items-center justify-content-center">
                                <p className="text-center">Change in Equity<br/>Since Beginning<br/>(in coffees)</p>
                                <input className={"fw-bold "+ GetColor(daveCoffeeData.coffees_equity[1]) } readOnly={true}  value={daveCoffeeData.coffees_equity[0]+"%"}/>
                              <img width="45" height="45" src={Tea} alt="coffee"/>
                              </div>
                              <div className="d-flex  gap-2 flex-column align-items-center justify-content-center">
                                <p className="text-center">Change in Cash Flow<br/>Since Beginning<br/>(in coffees)</p>
                                <input className={"fw-bold "+ GetColor(daveCoffeeData.coffees_cashflow[1]) } readOnly={true}  value={daveCoffeeData.coffees_cashflow[0]+"%"}/>
                                  <img width="45" height="45" src={Tea} alt="coffee"/>
                              </div>
                        </div>
                    </div>
                    {/* Sam */}
                    <div className="col-sm-6 col-md-6 px-1 RightArea">
                        <div className="d-flex bg-lightGray p-3 my-2 align-items-center justify-content-around border border-4 border-dark ">
                          <div className="d-flex gap-2  flex-column align-items-center justify-content-center">
                            <p className="text-center">Change in Equity<br/>Since Beginning<br/>(in coffees)</p>
                            <input className={"fw-bold "+ GetColor(samCoffeeData.coffees_equity[1]) } readOnly={true}  value={samCoffeeData.coffees_equity[0]+"%"}/>
                            <img width="45" height="45" src={Tea} alt="coffee"/>
                          </div>
                          <div className="d-flex  gap-2 flex-column align-items-center justify-content-center">
                            <p className="text-center">Change in Cash Flow<br/>Since Beginning<br/>(in coffees)</p>
                            <input className={"fw-bold "+ GetColor(samCoffeeData.coffees_cashflow[1]) } readOnly={true}  value={samCoffeeData.coffees_cashflow[0]+"%"}/>
                            <img width="45" height="45" src={Tea} alt="coffee"/>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            
            {/* graph box */}
            <div style={{display: `${coffeeCharToogle ? 'none':'block'}`}}>
              <div className="row mx-4" > 
                <div className="col-sm-6 col-md-6 px-1 leftArea">
                    <div className="boxGraph text-center d-flex flex-column bg-lightGray p-3 my-2 align-items-center justify-content-around border border-4 border-dark"> 
                    <p>In year <b>{daveCoffeeData.result.year}</b>, Dave has "made" <b>{daveCoffeeData.result.made}</b> through property appreciation. His exposure to inflation is <b>{daveCoffeeData.result.inflation}</b>, and his real tax rate is <b>{daveCoffeeData.result.taxRate}</b> with a <b className={GetColor(daveCoffeeData.result.with[1])}>{daveCoffeeData.result.with[0]}</b> of <b>{daveCoffeeData.result.withOf}</b> in purchasing power.</p>
                    <p>The goal is to maximize wealth by increasing the<br></br> green bars (gains) and decreasing the red bars (losses).</p>
                    <div style={{ height: '350px',width:'100%',position:'relative' }}>{daveChartDT.purchasingPower < 0 && <button onClick={showWarningpurchasingPower} className="btn btn-sm btn-warning btn-left" >Warning</button>} {daveChartDT.realTaxRate < 0 && <button className="btn btn-sm btn-warning btn-center" onClick={showWarningrealTaxRate} >Warning</button>} <BarGraph  data={daveChartData} options={chartOptions} /></div>
                </div>
                </div>
                <div className="col-sm-6 col-md-6 px-1 leftArea">
                    <div className="boxGraph text-center d-flex flex-column bg-lightGray p-3 my-2 align-items-center justify-content-around border border-4 border-dark"> 
                    <p>In year <b>{samCoffeeData.result.year}</b>, Sam has “made” <b>{samCoffeeData.result.made}</b> through property appreciation. His exposure to inflation is <b>{samCoffeeData.result.inflation}</b>, and his real tax rate is <b>{samCoffeeData.result.taxRate}</b> with a <b className={GetColor(samCoffeeData.result.with[1])}>{samCoffeeData.result.with[0]}</b> of <b>{samCoffeeData.result.withOf}</b> in purchasing power.</p> 
                    <p>The goal is to maximize wealth by increasing the<br></br> green bars (gains) and decreasing the red bars (losses).</p>
                    <div style={{ height: '350px',width:'100%',position:'relative' }}> {samChartDT.purchasingPower < 0 && <button onClick={showWarningpurchasingPower} className="btn btn-sm btn-warning btn-left" >Warning</button>} {samChartDT.realTaxRate < 0 && <button className="btn btn-sm btn-warning btn-center" onClick={showWarningrealTaxRate} >Warning</button>} <BarGraph  data={samChartData} options={chartOptions} /></div>
                    </div>
                </div>
              </div>
            </div>


          </div>
          
        )} 

        {isSidenavOpen && (
            <div id="mySidenav" class="sidenav" style={{ width: isSidenavOpen? '25%' : '0' }}>
              <a href="javascript:void(0)" class= "closebtn mt-1" onClick={toggleSidenav}>&times;</a>
              <div className="sidenav-content w-100 px-2  py-3 rounded-4" style={{fontSize:"16px"}}>
                <h5 className='ModalTitle fs-4 heading-font'>What's Happening?</h5>
                <p className="mb-2 mt-2 text-center">This simulation demonstrates what happens with wealth over time, with wealth gauged by one's capacity to enjoy an enhanced lifestyle, often referred to as 'Purchasing Power.'</p>
                <p className="mb-2 mt-2 text-center"> <b>What Does Coffee Represent?</b> </p>
                <p className="mb-3 text-justify  text-center">In this context, coffee serves as a symbolic representation – more coffee signifies an improved lifestyle.</p>
                <p className="mb-2 mt-2 text-center"> <b>Enhanced Lifestyle</b> </p>
                <p className="mb-3 text-justify  text-center">Observe how Sam's ability to purchase more coffees compared to Dave is growing, despite them owning identical properties. The key distinction lies in Sam having a well-structured mortgage. This increasing capability to afford more coffee over time not only highlights Sam's improving financial position but also serves as an indicator of his enhancing lifestyle.</p>                
                <p className="mb-2 mt-2 text-center"> <b>Exposure to Inflation</b> </p>
                <p className=" text-center">The "Exposure to Inflation" bar shows how much of the investment is exposed to inflation; 100% means it's 100% negatively impacted. This is like friction slowing you down. A mortgage acts as an "inflation-proof" vest, protecting some of the investment from inflation. Lower numbers are better. <br></br><br></br>20% 'Exposure to Inflation' indicates a 20% down payment with an 80% mortgage. This means the investor transfers 80% of inflation's negative impact to the lender, affecting only the 20% down payment. Smaller exposure to inflation boosts other metrics, including purchasing power.</p>
                <p className="mb-2 mt-2 text-center"> <b>Real Tax Rate</b> </p>
                <p className="mb-3 text-justify  text-center">The "Real Tax Rate" reflects taxes paid against inflation-adjusted profit. A high rate means paying more taxes on inflation-adjusted profit. Aim for a low rate to retain more of this profit.</p>
                 <Link onClick={toggleSidenav} className="threeDButton text-white w-100 btn fw-bold text-center">Hide</Link>
            </div>
            </div>
          )}

      </div>
      {/* modal warming start*/}
      {purchasingPowerModalOpen && (
        <Modal centered
        open={purchasingPowerModalOpen}
          mask={true}
        closable={false}
        onOk={() => setpurchasingPowerModalOpen(false)}
        okText='Okay'
        footer={(_, { OkBtn }) => (
          <>
            <OkBtn className=" threeDButton btn fw-bold" />
          </>
        )}
        >
          {/* Your modal content here */}
         <div className="text-center">
         <h5 className='ModalTitle fs-4'>Warning</h5>
          <p className="mb-3 text-center">A negative Purchasing Power is not good!</p>
          <p className="mb-3 text-justify">It means inflation increased at a higher rate than your property appreciated. You might think you are doing well financially; you are actually moving backwards in terms of purchasing power.</p>
          <p className="mb-3 text-justify">It’s like you are in a race, running forward, only to find out the finish line is moving away from you at a faster pace. So even though you are moving forward, you are moving backwards relative to the finish line.</p>
          <p className="mb-3 text-center">We call this a “sinking ship.“</p> 
          </div> 
        </Modal>
      )}
       {realTaxRateModalOpen && (
        <Modal centered
        open={realTaxRateModalOpen}
          mask={true}
        closable={false}
        onOk={() => setrealTaxRateModalOpen(false)}
        okText='Okay'
        footer={(_, { OkBtn }) => (
          <>
            <OkBtn className=" threeDButton btn fw-bold" />
          </>
        )}
        >
          {/* Your modal content here */}
         <div className="text-center">
         <h5 className='ModalTitle fs-4'>Warning</h5>
          <p className="mb-3 text-justify">The "Real Tax Rate" reflects taxes paid against inflation-adjusted profit. A high-rate means you are paying more taxes on inflation-adjusted profit. </p>
          <p>Now… Brace yourself!</p>
          <p className="mb-3 text-justify">A negative Real Tax Rate implies you're taxed on profits you didn't actually earn due to inflation outpacing your asset's appreciation, reducing your purchasing power. It means you’re not just losing purchasing power, but you are also paying taxes on “profits” you never made. This might seem counter-intuitive, but it happens often. </p>
          <p className="mb-3 text-justify">Even though the property appreciated, and you “made” money, that money buys you less coffee than when you first purchased the property. So you lost purchasing power, and you then pay taxes on that “profit” from the appreciation. </p>
          <p className="mb-3 text-center">This “hidden tax” is a double blow to your wealth!</p> 
          </div> 
        </Modal>
      )}
    {/*modal warming end */}
      <Modal centered className='border-3 rounded-4 '
        open={open}
        mask={true}
        closable={false}
        onOk={handleOk}
        okText='Show Me Lesson'
        width='75%'
        footer={(_, { OkBtn }) => (
          <>
            <OkBtn className=" threeDButton btn fw-bold" />
          </>
        )}
      >
        <div className=" px-2  py-3 rounded-4">
        <h5 className='ModalTitle fs-4'>What's Happening?</h5>
        <p className="mb-2 text-center">This screen is showing you what happens with wealth over time.</p>
        <p className="mb-3 text-justify">Notice how Sam's number of coffees is increasing relative to Dave even though they own identical properties. The only difference is that Sam has a mortgage. Notice that Sam's ability to afford more coffee over time is increasing. The coffee is a reflection of his lifestyle.</p>
        <b className="text-center d-block">(if "Numerical Results" toggle is on)</b>
        <p className="mb-3 text-justify">The Gain in Dollars shows the gain someone is making in dollars. This is part of the illusion. This does not account for how much the prices of everything else has gone up. When prices of everything else is increasing at a faster rate than the gains from your investments, it means your ability to purchase these items is decreasing. You must consider Purchasing Power to get an idea of how the investment is performing overall. Both these numbers must be increasing over time.</p>
        <b className="text-center d-block">(if "Numerical Results" toggle is on)</b>
        <p>The Real Tax Rate is based on the taxes paid relative to purchasing power. A high true tax rate means someone is paying a large percentage of their inflation-adjusted profit in taxes. The goal is to have a low true tax rate and keep more of your inflation-adjusted profit.</p>
        <b  className="text-center d-block">(if "Show Exposure to Inflation" toggle is on)</b>
        <p className="mb-3 text-justify">The Exposure to Inflation shows you how much of the investment is exposed to inflation. A 100% means inflation is 100% negatively impacting your investment. This is like friction. Inflation is pushing you backwards. A mortgage acts as an "inflation-proof" vest to protect your investment from some inflation. The lower the number, the better.</p>
        </div>
      </Modal>
     
    </>
  );
}


export default PersonalizeSimulationDecisionMaking;